/*------------------------------------------------
// File Name:PDM_BodyCheck_PaiBan.js
// File Description:PDM_BodyCheck_PaiBan store方法
// Author:zxl
// Create Time:2023/04/06 15:38:12
//------------------------------------------------*/

import {
    GetPDM_BodyCheck_PaiBanList,
    GetPDM_BodyCheck_PaiBanListByPage,
    GetPDM_BodyCheck_PaiBanEntity,
    CreatePDM_BodyCheck_PaiBanEntity,
    UpdatePDM_BodyCheck_PaiBanEntity,
    DeletePDM_BodyCheck_PaiBanEntity,
} from '@/api/pdm/bodycheckPaiban'

import msg from '@/config/notify'
import dlg from '@/config/dialog'
//import { toRaw } from "vue";

export const PdmBodycheckPaiban = {
    namespaced: true,
    state: {
        PdmBodycheckPaibanList: [],
        PdmBodycheckPaibanListLoading: false,
        PdmBodycheckPaibanEntity: null,
        PdmBodycheckPaibanShowDlg: false,
        PaiBanData:[],
        Years: null,//年
        Month: null,//月
    },
    mutations: {
        setPaiBanData(state, dataList) {
            state.PaiBanData = [...dataList]
        },
        setYears(state, visible) {
            state.Years = visible
        },
        setMonth(state, visible) {
            state.Month = visible
        },
        setPdmBodycheckPaibanList(state, dataList) {
            state.PdmBodycheckPaibanList = [...dataList]
        },
        setPdmBodycheckPaibanListLoading(state, visible) {
            state.PdmBodycheckPaibanListLoading = visible
        },
        setPdmBodycheckPaibanShowDlg(state, visible) {
            state.PdmBodycheckPaibanShowDlg = visible
        },
        setPdmBodycheckPaibanEntity(state, entity) {
            state.PdmBodycheckPaibanEntity = entity
        },
    },
    actions: {
        //创建排班表对象
        actCreatePdmBodycheckPaiban({ commit }, parm) {
            return new Promise((resolve, reject) => {
                CreatePDM_BodyCheck_PaiBanEntity(parm).then(res => {
                    if (res.Code == 0) {
                        commit('setPdmBodycheckPaibanEntity', res.Data)
                        commit('setPdmBodycheckPaibanShowDlg', true)
                         //msg.success(res.Message)
                        resolve(res)
                    } else {
                        dlg.alert(res.Message)
                        reject(res)
                    }
                })
            }).catch(err => {
                console.log(err)
            })
        },
        //加载排班表对象
        actGetPdmBodycheckPaibanEntity({ commit }, parm) {
            return new Promise((resolve) => {
                commit('setPdmBodycheckPaibanListLoading', true)
                GetPDM_BodyCheck_PaiBanEntity(parm).then(res => {
                    if (res.Code == 0) {
                        commit('setPdmBodycheckPaibanEntity', res.Data)
                        //msg.success(res.Message)
                        resolve(res)
                    } else {
                        dlg.alert(res.Message)
                        //msg.error(res.Message)
                    }
                }).finally(() => {
                    commit('setPdmBodycheckPaibanListLoading', false)
                })
            }).catch(err => {
                console.log(err)
            })
        },
        //加载排班表列表
        actGetPdmBodycheckPaibanList({ commit }, parm) {
            return new Promise((resolve) => {
                commit('setPdmBodycheckPaibanListLoading', true)
                GetPDM_BodyCheck_PaiBanList(parm).then(res => {
                    if (res.Code == 0) {
                        commit('setPdmBodycheckPaibanList', res.Data)
                        //msg.success(res.Message)
                        resolve(res)
                    } else {
                        dlg.alert(res.Message)
                        //msg.error(res.Message)
                    }
                }).finally(() => {
                    commit('setPdmBodycheckPaibanListLoading', false)
                })
            }).catch(err => {
                console.log(err)
            })
        },
        //分页加载排班表列表
        actGetPdmBodycheckPaibanListByPage({ commit }, parm) {
            return new Promise((resolve) => {
                commit('setPdmBodycheckPaibanListLoading', true)
                GetPDM_BodyCheck_PaiBanListByPage(parm).then(res => {
                    if (res.Code == 0) {
                        commit('setPdmBodycheckPaibanList', res.Data)
                        //msg.success(res.Message)
                        resolve(res)
                    } else {
                        dlg.alert(res.Message)
                       // msg.error(res.Message)
                    }
                }).finally(() => {
                    commit('setPdmBodycheckPaibanListLoading', false)
                })
            }).catch(err => {
                console.log(err)
            })
        },
        //保存排班表信息
        actUpdatePdmBodycheckPaiban({ commit }, parm) {
            return new Promise((resolve) => {
                UpdatePDM_BodyCheck_PaiBanEntity(parm).then(res => {
                    if (res.Code == 0) {
                        commit('setPdmBodycheckPaibanShowDlg', false)
                        msg.success(res.Message)
                        resolve(res)
                    } else {
                        dlg.alert(res.Message)
                        resolve(res)
                    }
                })
            }).catch(err => {
                console.log(err)
            })
        },
        //编辑PDM_BodyCheck_PaiBan
        actEditPdmBodycheckPaibanData({ commit }, entity) {
            return new Promise((resolve) => {
                let parm = {                    
                    PdmBodycheckPaibanID : entity.PdmBodycheckPaibanID
                }
                GetPDM_BodyCheck_PaiBanEntity(parm).then(res => {
                    if (res.Code == 0) {
                        // var info = {}
                        // Object.assign(info,state.getTableNameL3(TableName.Name)%>Entity)
                        // Object.assign(info,res.Data)
                        // commit('getTableNameL3(TableName.Name)%>Entity', info)
                        commit('setPdmBodycheckPaibanEntity', res.Data)
                        commit('setPdmBodycheckPaibanShowDlg', true)
                        msg.success(res.Message)
                        resolve(res)
                    } else {
                        dlg.alert(res.Message)
                        resolve(res)
                    }
                })
            }).catch(err => {
                console.log(err)
            })
        },
        //编辑PDM_BodyCheck_PaiBan ,传对象过来
        actEditPdmBodycheckPaiban({ commit }, entity) {
            return new Promise(() => {
                commit('setPdmBodycheckPaibanEntity', entity)
                commit('setPdmBodycheckPaibanShowDlg', true)
            }).catch(err => {
                console.log(err)
            })
        },
        //删除PDM_BodyCheck_PaiBan
        actDeletePdmBodycheckPaiban({ commit }, e) {
            return new Promise((resolve) => {
                dlg.confirm("是否确定要删除当前排班表？").onOk(() => {
                    DeletePDM_BodyCheck_PaiBanEntity(e).then(res => {
                        if (res.Code == 0) {
                            commit('setPdmBodycheckPaibanShowDlg', false)
                           
                            msg.success("删除排班表成功。")
                            resolve(res)
                        } else {
                            dlg.alert("删除排班表失败，原因:" + res.Message)
                            //msg.success("删除排班表失败，原因:" + res.Message)
                            resolve(res)
                        }
                    })
                })
            }).catch(err => {
                console.log(err)
            })
        }
    }
}


